



























































































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import CreateProductMigrationRequest from '@/models/Products/ProductMigrations/CreateProductMigrationRequest';
import ProductIssueMigrationType from '@/models/Products/ProductMigrations/ProductIssueMigrationType';
import Product from '@/models/Products/Product';
import ProductIssue from '@/models/Products/ProductIssues/ProductIssue';
import PageNames from '@/router/PageNames';

@Component({ name: 'ProductMigrationCreateDialog' })
export default class extends SaascadaVueDialog {

    ProductIssueMigrationType = ProductIssueMigrationType;
    request: CreateProductMigrationRequest = new CreateProductMigrationRequest();
    currentPage: number = 1;
    fromProduct: Product = null;
    fromProductIssue: ProductIssue = null;
    toProductIssue: ProductIssue = null;
    fromProductIssueSelection: string = ProductIssueMigrationType.MigrateAll;
    toProductIssueSelection: string = ProductIssueMigrationType.MigrateCurrent;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // Reset values when the modal opens
            this.request = new CreateProductMigrationRequest();
            this.currentPage = 1;
            this.fromProduct = null;
            this.fromProductIssue = null;
            this.toProductIssue = null;
            this.fromProductIssueSelection = ProductIssueMigrationType.MigrateAll;
            this.toProductIssueSelection = ProductIssueMigrationType.MigrateCurrent;
            // Get products for the list
            await ProductMigrationModule.getProductsForMigration();
        }
    }

    @Watch('fromProduct')
    async onFromProductChanged() {
        this.setMigrationName();
        if (this.fromProduct) {
            await ProductMigrationModule.getProductIssuesForMigration(this.fromProduct.id);
        }
    }

    @Watch('fromProductIssue')
    async onFromProductIssueChanged() {
        this.setMigrationName();
    }

    @Watch('toProductIssue')
    async onToProductIssueChanged() {
        this.setMigrationName();
    }

    @Watch('fromProductIssueSelection')
    async onFromProductIssueSelectionChanged() {
        this.setMigrationName();
    }

    @Watch('toProductIssueSelection')
    async onToProductIssueSelectionChanged() {
        this.setMigrationName();
    }

    async setMigrationName() {
        // The "from" text in the migration name
        let fromText = "";
        if (this.fromProductIssueSelection === ProductIssueMigrationType.MigrateAll) {
            fromText = this.$t('pageText.productMigrations.fields.migrationNameAllAccounts').toString();
        }
        if (this.fromProductIssueSelection === ProductIssueMigrationType.MigrateCurrent) {
            fromText = this.$t('pageText.productMigrations.fields.migrationNameAllAccountsOnCurrentIssue').toString();
        }
        if (this.fromProductIssueSelection === ProductIssueMigrationType.MigrateSpecific) {
            if (this.fromProductIssue) {
                fromText = `${this.$t('pageText.productMigrations.fields.migrationNameAllAccountsOn')} ${this.fromProductIssue.name}`;
            }
            else {
                fromText = this.$t('pageText.productMigrations.fields.migrationNameAllAccountsOnSpecificIssue').toString();
            }
        }
        // The "to" text in the migration name
        let toText = "";
        if (this.toProductIssueSelection === ProductIssueMigrationType.MigrateCurrent) {
            toText = this.$t('pageText.productMigrations.fields.migrationNameToCurrentIssue').toString();
        }
        if (this.toProductIssueSelection === ProductIssueMigrationType.MigrateSpecific) {
            if (this.toProductIssue) {
                toText = `${this.$t('pageText.productMigrations.fields.migrationNameTo')} ${this.toProductIssue.name}`;
            }
            else {
                toText = this.$t('pageText.productMigrations.fields.migrationNameToSpecificIssue').toString();
            }
        }
        // Put it all together
        this.request.name = `${this.$t('pageText.productMigrations.fields.migrationNameMigrate')} ${fromText} ${toText}`;
    }

    get productOptions() {
        return ProductMigrationModule.productsForMigration;
    }

    get fromProductIssuesOptions() {
        // Filter out any selected issue in the toProduct so that the same issue can't be selected twice
        let productIssuesOptions = ProductMigrationModule.productIssuesForMigration;
        if (this.toProductIssue) {
            productIssuesOptions = productIssuesOptions.filter((productIssue) => {
                return productIssue.code !== this.toProductIssue.code;
            });
        }
        return productIssuesOptions;
    }

    get toProductIssuesOptions() {
        // Filter out any selected issue in the fromProduct so that the same issue can't be selected twice
        let productIssuesOptions = ProductMigrationModule.productIssuesForMigration;
        if (this.fromProductIssue) {
            productIssuesOptions = productIssuesOptions.filter((productIssue) => {
                return productIssue.code !== this.fromProductIssue.code;
            });
        }
        return productIssuesOptions;
    }

    get totalProductIssuesOptions() {
        // Get the total number of issues without filtering
        return ProductMigrationModule.productIssuesForMigration.length;
    }

    get productLoading() {
        return ProductMigrationModule.loadingMigrationProducts;
    }

    get productIssuesLoading() {
        return ProductMigrationModule.loadingMigrationProductIssues;
    }

    async cancel() {
        this.dialog = false;
    }

    async next() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.currentPage = 2;
        }
    }

    async back() {
        this.currentPage = 1;
    }

    async create() {
        this.dialog = false;

        this.request.fromProductId = this.fromProduct.id;
        // Set the fromProductIssueId based on the selected option in fromProductIssueSelection
        if (this.fromProductIssueSelection === ProductIssueMigrationType.MigrateAll) {
            this.request.fromProductIssueId = undefined;
        }
        else if (this.fromProductIssueSelection === ProductIssueMigrationType.MigrateCurrent) {
            // Take the first issue in the list which should be the newest/current issue
            this.request.fromIsCurrentProductIssue = true;
            this.request.fromProductIssueId = this.fromProductIssuesOptions[0].id;
        }
        else {
            this.request.fromProductIssueId = this.fromProductIssue.id;
        }

        // For now only allow migrating to the same product, so copy the ID in fromProduct to toProduct
        this.request.toProductId = this.fromProduct.id;
        // Set the toProductIssueId based on the selected option in toProductIssueSelection
        if (this.toProductIssueSelection === ProductIssueMigrationType.MigrateCurrent) {
            // Take the first issue in the list which should be the newest/current issue
            this.request.toProductIssueId = this.toProductIssuesOptions[0].id;
        }
        else {
            this.request.toProductIssueId = this.toProductIssue.id;
        }

        await ProductMigrationModule.createProductMigration(this.request);

        if (ProductMigrationModule.newProductMigrationId !== null) {
            this.$router.push({ name: PageNames.ProductMigration, params: { id: ProductMigrationModule.newProductMigrationId } });
        }
    }

}
